import React from "react";
import "./Switch.sass";

/**
 * Reusable toggle switch component.
 *
 * @param {object}   props
 * @param {string}   props.id        - unique id for accessibility (ties to label htmlFor)
 * @param {boolean}  props.checked   - current on/off state
 * @param {Function} props.onChange  - called (without args) when user clicks
 * @param {boolean}  [props.disabled]
 * @param {string}   [props.label]   - aria-label for the button (if no external label)
 */
const Switch = ({ id, checked, onChange, disabled = false, label }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    id={id}
    className={`ui-switch${checked ? " ui-switch--on" : ""}${disabled ? " ui-switch--disabled" : ""}`}
    onClick={disabled ? undefined : onChange}
    aria-label={label}
    aria-disabled={disabled}
  >
    <span className="ui-switch__track">
      <span className="ui-switch__thumb" />
    </span>
  </button>
);

export default Switch;
